(function () {
  var instances = new WeakMap();

  function init(root) {
    var nav = root.querySelector('[data-phx-navrow]');
    if (!nav || instances.has(root)) return;

    var controller = new AbortController();
    var desktop = window.matchMedia('(min-width: 1150px)');
    var subs = Array.from(nav.querySelectorAll('[data-phx-sub]'));
    var panels = Array.from(nav.querySelectorAll('[data-phx-scroll-panel]'));
    var frame = 0;

    function resetSub(sub) {
      sub.style.removeProperty('--phx-flyout-max-height');
      sub.style.removeProperty('max-height');
      sub.style.removeProperty('overflow-y');
      sub.style.removeProperty('overscroll-behavior');
      sub.style.removeProperty('scrollbar-width');
    }

    function positionSub(sub) {
      var item = sub.parentElement;
      var owner = item.closest('[data-phx-item]');
      if (!desktop.matches) { resetSub(sub); return; }
      if (!owner || !owner.classList.contains('is-open') || !item.classList.contains('is-open')) return;
      var top = sub.getBoundingClientRect().top;
      var viewport = window.visualViewport;
      var bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      var available = Math.min(480, Math.max(0, Math.floor(bottom - top - 16)));
      sub.style.setProperty('--phx-flyout-max-height', available + 'px');
      sub.style.maxHeight = available + 'px';
      sub.style.overflowY = 'auto';
      sub.style.overscrollBehavior = 'contain';
      sub.style.scrollbarWidth = 'thin';
    }

    function refresh() {
      frame = 0;
      subs.forEach(positionSub);
      panels.forEach(function (panel) {
        if (!desktop.matches) { resetSub(panel); return; }
        var owner = panel.closest('[data-phx-item]');
        if (!owner || !owner.classList.contains('is-open')) return;
        var viewport = window.visualViewport;
        var bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        var limit = Number(panel.getAttribute('data-phx-scroll-panel'));
        if (!Number.isFinite(limit) || limit <= 0) return;
        panel.style.maxHeight = Math.min(limit, Math.max(0, Math.floor(bottom - nav.getBoundingClientRect().bottom - 16))) + 'px';
        panel.style.overflowY = 'auto';
        panel.style.overscrollBehavior = 'contain';
        panel.style.scrollbarWidth = 'thin';
      });
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(refresh);
    }

    var observer = new MutationObserver(function (records) {
      if (records.some(function (record) { return record.target.matches('[data-phx-item], [data-phx-cas]'); })) schedule();
    });
    observer.observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', schedule, { signal: controller.signal });
    window.addEventListener('scroll', schedule, { capture: true, passive: true, signal: controller.signal });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { signal: controller.signal });
      window.visualViewport.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
    }
    var resize = new ResizeObserver(schedule);
    resize.observe(root);
    instances.set(root, function () {
      controller.abort();
      observer.disconnect();
      resize.disconnect();
      if (frame) cancelAnimationFrame(frame);
      subs.forEach(resetSub);
      panels.forEach(resetSub);
    });
    schedule();
  }

  function findRoots(scope) {
    scope.querySelectorAll('[data-phx]').forEach(function (bar) {
      var root = bar.closest('.shopify-section');
      if (root) init(root);
    });
  }

  findRoots(document);
  document.addEventListener('shopify:section:load', function (event) { findRoots(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var destroy = instances.get(event.target);
    if (destroy) { destroy(); instances.delete(event.target); }
  });
})();
